
export default {
    install (Vue, options) {

        /**
         * [imgErr 图片地址无效的替换地址]
         * @param  {[type]} event [event对象]
         * @return {[type]}       [src地址]
         */
        let imgErr = (event) => {
            let evt = window.event || event
            let targetEle = evt.target || evt.srcElement
            targetEle.onerror = null
            targetEle.src = '/static/images/default.png'
        }
        Object.defineProperty(Vue.prototype, "$imgErr", {
            value: imgErr
        })

        /**
         * [commentImgErr  评论图片地址无效的替换地址]
         * @param  {[type]} event [event对象]
         * @return {[type]}       [src地址]
         */
        let commentImgErr = (event) => {
            let evt = window.event || event
            let targetEle = evt.target || evt.srcElement
            targetEle.onerror = null
            targetEle.src = '/static/images/before_load.png'
        }
        Object.defineProperty(Vue.prototype, "$commentImgErr", {
            value: commentImgErr
        })


        /**
         * [图片展位图]
         * @param  {[type]} event    [description]
         * @param  {[type]} relative [位置关系 默认相邻兄弟 parent 父级]
         * @return {[type]}          [description]
         */
        let placeImg = (event, relative) => {
            let evt = window.event || event
            let targetEle = evt.target || evt.srcElement
            if (targetEle.parentNode && relative && relative === 'parent') {
                targetEle.parentNode.style.opacity = 1
                targetEle.onload = null
                targetEle.parentNode.removeChild(targetEle)
                return
            }
            if (!targetEle.previousElementSibling) return
            targetEle.previousElementSibling.style.opacity = 1
            targetEle.onload = null
            targetEle.parentNode.removeChild(targetEle)
        }
        Object.defineProperty(Vue.prototype, "$placeImg", {
            value: placeImg
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js